import React from 'react';
import { ReactSVG } from "react-svg";
import i18n from '../../i18n/i18n.js';
import { Link  } from "react-router-dom";
import {Utils} from '../../Utils.js';
import './AppFooterMenu.css';
import useDetectKeyboardOpen from 'use-detect-keyboard-open';

const HideOnKeyboardOpen = (props)=>{

  const isKeyboardOpen = useDetectKeyboardOpen(250);
  const children = (props.children) ? props.children : null;

  return <div style={{visibility:((isKeyboardOpen) ? 'hidden' : 'visible')}}>{children}</div>
}


class AppFooterMenu extends React.Component {

  constructor(props){
      
    super(props);

    this.state = {
      menu_items : {
        home:{path:'',ref_obj_name:null,active:false},
        sale:{path:'sale',ref_obj_name:null,active:false},
        menu_profile:{path:null,ref_obj_name:'ProfileMenuRef',active:false},
        products_menu:{path:null,ref_obj_name:'ProductsMenuRef',active:false},
        shopping_cart:{path:null,ref_obj_name:'ShoppingCartRef',active:false},
      },
      shopping_cart:{}
    };
  }

  set_shopping_cart(shopping_cart)
  {
    this.setState({shopping_cart:shopping_cart});
  }

  componentDidMount()
  {
    if(window.AppRef.current?.state?.shopping_cart)
    {
      this.set_shopping_cart(window.AppRef.current.state.shopping_cart);
    }
  }

  set_item_inactive_by_name(item_name)
  {
    this.state.menu_items[item_name].active = false;
    this.setState(this.state);
  }

  hide_all_menu_item() {
    Object.keys(window.modals).forEach((key,index)=>{
      if(window.modals[key].current){
        window.modals[key].current.hide();
      }
    });
  }

  menu_item_is_active(item_name){

    if(Object.keys(this.state.menu_items[item_name]).length>0)
    {
      if(!this.state.menu_items[item_name].ref_obj_name) //path alapján kell eldönteni hogy aktív-e az oldal
      {
        const path = Utils.get_path_from_url();

        if(path===this.state.menu_items[item_name].path)
        {
          let has_active_modal = false;

          for (const [key, value] of Object.entries(this.state.menu_items)) {
            if(this.state.menu_items[key].ref_obj_name && this.state.menu_items[key].active===true){
              has_active_modal = true;
            }
          }

          if(!has_active_modal)
          {
            this.state.menu_items[item_name].active=true;
          }
        }
        else
        {
          this.state.menu_items[item_name].active=false;
        }
      }

      return this.state.menu_items[item_name].active;
    }
    else
    {
      return false;
    }

  }

  handle_item_click(item_name){

    if(Object.keys(this.state.menu_items[item_name]).length>0)
    {
      if(!this.state.menu_items[item_name].ref_obj_name) //path alapján kell eldönteni hogy aktív-e az oldal
      {
        Object.keys(window.modals).forEach((key,index)=>{
          if (typeof window?.modals[key]?.current?.hide !== 'undefined')
          {
            window.modals[key].current.hide();
          } 
        });

        for (const [key, value] of Object.entries(this.state.menu_items)) {
          this.state.menu_items[key].active=false;
        }

        window.dispatchEvent(new CustomEvent('hideProductFilters'));
      }
      else //modal
      {
        Object.keys(window.modals).forEach((key,index)=>{
          if (key !== this.state.menu_items[item_name].ref_obj_name)
          {
            if (typeof window?.modals[key]?.current?.hide !== 'undefined')
            {
              window.modals[key].current.hide();
            }
          }
        });

        window.modals[this.state.menu_items[item_name].ref_obj_name].current.show();

        for (const [key, value] of Object.entries(this.state.menu_items)) {
          this.state.menu_items[key].active=false;
        }

        this.state.menu_items[item_name].active = true;
        window.dispatchEvent(new CustomEvent('hideProductFilters'));
      }

      this.setState(this.state);
    }

  }

  render() {

    return (
      <HideOnKeyboardOpen>
        <footer>
          <div className="menu">
            <Link data-type="home" to="/" onClick={()=>this.handle_item_click('home')}>
              {!this.menu_item_is_active('home') ? <div className="fade"></div>: ''}
              <div className="icon"><ReactSVG src={`assets/images/home.svg`} /></div>      
              <div className="title">{i18n.t('footerMenuHome')}</div>      
            </Link>
          </div>

          <div className="menu">
            <div onClick={() => this.handle_item_click('products_menu') }>  
              {!this.menu_item_is_active('products_menu') ? <div className="fade"></div>: ''}
              <div className="icon"><ReactSVG src={`assets/images/menu_products.svg`} /></div>      
              <div className="title">{i18n.t('footerMenuProducts')}</div>      
            </div>
          </div>

          <div className="menu"> 
            <Link to={"/products/"+window.AppRef.current.state.sale_url} onClick={()=>this.handle_item_click('sale')}>
              {!this.menu_item_is_active('sale') ? <div className="fade"></div>: ''}
              <div className="icon"><ReactSVG src={`assets/images/menu_sale.svg`} /></div>      
              <div className="title">{i18n.t('footerMenuSales')}</div>      
            </Link>
          </div>

          <div className="menu">
            <div onClick={() => this.handle_item_click('shopping_cart') }>  
              {!this.menu_item_is_active('shopping_cart') ? <div className="fade"></div>: ''}
              <div className="icon">
                {(this.state.shopping_cart && this.state.shopping_cart.pc_total) ? <span className='cart_item_count'>{this.state.shopping_cart.pc_total}</span> : ''}
                <ReactSVG src={`assets/images/menu_cart.svg`} />
              </div>      
              <div className="title">{i18n.t('footerMenuCart')}</div>      
            </div>
          </div>

          <div className="menu">
            <div onClick={() => this.handle_item_click('menu_profile') }>  
              {!this.menu_item_is_active('menu_profile') ? <div className="fade"></div>: ''}
              <div className="icon"><ReactSVG src={`assets/images/menu_profile.svg`} /></div>      
              <div className="title">{i18n.t('footerMenuProfile')}</div>      
            </div>
          </div>
        </footer>
      </HideOnKeyboardOpen>
      
    );
  }
  
};

export default AppFooterMenu;
